import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericDatePicker } from '../../components';
import { InputModel } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithoutSource } from '../../componentTypes';


const PeriodStartInput: InputWithoutSource = ({ input }) => (
    <GenericDatePicker label={input.name} input={input} message={ValidationMessages.requiredInput(input.name)} />
);

PeriodStartInput.meta = {
    inputType: InputModel.name
};

export default observer(PeriodStartInput);
